/* eslint-disable max-lines-per-function */
import { useMemo } from "react";
import getIsServiceValid from "./getIsServiceValid";
import useHasReleaseDate from "./useHasReleaseDate";
const useIsAddHomeVideoReviewEnabled = ({ homeVideoReview, isImdbIdValid, loading, services }) => {
    const hasName = useMemo(() => Boolean(isImdbIdValid || homeVideoReview.name), [isImdbIdValid, homeVideoReview.name]);
    const isAddHomeVideoValid = useMemo(() => homeVideoReview.isAddHomeVideo && hasName, [homeVideoReview.isAddHomeVideo, hasName]);
    const isHomeVideoIdValid = useMemo(() => !homeVideoReview.isAddHomeVideo && Boolean(homeVideoReview.homeVideoId), [homeVideoReview.homeVideoId, homeVideoReview.isAddHomeVideo]);
    const isHomeVideoValid = useMemo(() => isAddHomeVideoValid || isHomeVideoIdValid, [isAddHomeVideoValid, isHomeVideoIdValid]);
    const areImagesValid = useMemo(() => {
        if (!homeVideoReview.isAddHomeVideo) {
            return true;
        }
        if (homeVideoReview.images?.length) {
            return true;
        }
        return false;
    }, [homeVideoReview.images?.length, homeVideoReview.isAddHomeVideo]);
    const hasReleaseDate = useHasReleaseDate(services);
    const hasValidServices = useMemo(() => getIsServiceValid(services.avForums.url, services.avForums.isPreviewValid) &&
        getIsServiceValid(services.avNirvana.url, services.avNirvana.isPreviewValid) &&
        getIsServiceValid(services.avsForum.url, services.avsForum.isPreviewValid) &&
        getIsServiceValid(services.bluRay.url, services.bluRay.isPreviewValid) &&
        getIsServiceValid(services.bluRayAuthority.url, services.bluRayAuthority.isPreviewValid) &&
        getIsServiceValid(services.digitalBits.url, services.digitalBits.isPreviewValid) &&
        getIsServiceValid(services.doBlu.url, services.doBlu.isPreviewValid) &&
        getIsServiceValid(services.hidefDigest.url, services.hidefDigest.isPreviewValid) &&
        getIsServiceValid(services.highDefDiscNews.url, services.highDefDiscNews.isPreviewValid) &&
        getIsServiceValid(services.homeTheaterForum.url, services.homeTheaterForum.isPreviewValid) &&
        getIsServiceValid(services.theaterByte.url, services.theaterByte.isPreviewValid) &&
        getIsServiceValid(services.whySoBlu.url, services.whySoBlu.isPreviewValid), [services]);
    return useMemo(() => areImagesValid &&
        hasName &&
        hasReleaseDate &&
        hasValidServices &&
        isHomeVideoValid &&
        !loading, [
        areImagesValid,
        hasName,
        hasReleaseDate,
        hasValidServices,
        isHomeVideoValid,
        loading
    ]);
};
export default useIsAddHomeVideoReviewEnabled;
